"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var lab_1 = require("@material-ui/lab");
var core_1 = require("@21st-night/core");
var NEEDS_WORK = core_1.PROFICIENCY_KEYS.NEEDS_WORK, IN_PROGRESS = core_1.PROFICIENCY_KEYS.IN_PROGRESS;
var DeckMessages = function (_a) {
    var deck = _a.deck, user = _a.user, other = __rest(_a, ["deck", "user"]);
    var hasSeenAnalytics = true;
    var uncategorizedCardsCount = 0;
    var insuficientCategories = false;
    var hasReviewedRecently = !!deck.lastReview;
    var hasReviewedOldCardsRecently = true;
    var longPreviousSession = false;
    var shortPreviousSession = false;
    var previousSessionLength = 0;
    var redCategories = [];
    var redSubcategories = [];
    var orangeCategories = [];
    var orangeSubcategories = [];
    var needsReviewing = '';
    var needsReviewingType = 'category';
    var showStudentMessages = !deck.hasRole('teacher') || !user.deckIds.includes(deck.id);
    deck.cards.forEach(function (card) {
        if (!card.category && card.subcategories.length === 0) {
            uncategorizedCardsCount += 1;
        }
        if (!card.notStarted &&
            dayjs_1.default(core_1.toDate(card.lastReview)).isBefore(dayjs_1.default(new Date()).subtract(7, 'day'))) {
            hasReviewedOldCardsRecently = false;
        }
    });
    if (deck.cards.length > 4 &&
        uncategorizedCardsCount / deck.cards.length > 0.5) {
        insuficientCategories = true;
    }
    if (deck.lastReview &&
        dayjs_1.default(core_1.toDate(deck.lastReview.startedAt)).isBefore(dayjs_1.default().subtract(12, 'hour'))) {
        hasReviewedRecently = false;
        longPreviousSession = deck.lastReview.duration > 15 * 60;
        shortPreviousSession = deck.lastReview.duration < 15 * 60;
        previousSessionLength = Math.round(deck.lastReview.duration / 60) || 1;
    }
    if (!hasReviewedRecently) {
        deck.cards.forEach(function (card) {
            var proficiency = core_1.getProficiencyKey(card);
            if (core_1.toDate(card.nextReview) < new Date()) {
                if (proficiency === NEEDS_WORK) {
                    redSubcategories = __spreadArray(__spreadArray([], __read(redSubcategories)), __read(card.subcategories));
                    if (card.category) {
                        redCategories.push(card.category);
                    }
                }
                else if (proficiency === IN_PROGRESS) {
                    orangeSubcategories = __spreadArray(__spreadArray([], __read(orangeSubcategories)), __read(card.subcategories));
                    if (card.category) {
                        orangeCategories.push(card.category);
                    }
                }
            }
        });
        var redCategoryCounts_1 = redCategories.reduce(function (counts, category) {
            var _a;
            return __assign(__assign({}, counts), (_a = {}, _a[category] = counts[category] ? counts[category] + 1 : 1, _a));
        }, {});
        var redSubcategoryCounts_1 = redSubcategories.reduce(function (counts, category) {
            var _a;
            return __assign(__assign({}, counts), (_a = {}, _a[category] = counts[category] ? counts[category] + 1 : 1, _a));
        }, {});
        var orangeCategoryCounts_1 = orangeCategories.reduce(function (counts, category) {
            var _a;
            return __assign(__assign({}, counts), (_a = {}, _a[category] = counts[category] ? counts[category] + 1 : 1, _a));
        }, {});
        var orangeSubcategoryCounts_1 = orangeSubcategories.reduce(function (counts, category) {
            var _a;
            return __assign(__assign({}, counts), (_a = {}, _a[category] = counts[category] ? counts[category] + 1 : 1, _a));
        }, {});
        var maxCount_1 = 0;
        Object.keys(redCategoryCounts_1).forEach(function (category) {
            if (redCategoryCounts_1[category] > maxCount_1) {
                needsReviewing = category;
                maxCount_1 = redCategoryCounts_1[category];
            }
        });
        Object.keys(redSubcategoryCounts_1).forEach(function (category) {
            if (redSubcategoryCounts_1[category] > maxCount_1) {
                needsReviewing = category;
                maxCount_1 = redSubcategoryCounts_1[category];
                needsReviewingType = 'subcategory';
            }
        });
        if (maxCount_1 === 0) {
            Object.keys(orangeCategoryCounts_1).forEach(function (category) {
                if (orangeCategoryCounts_1[category] > maxCount_1) {
                    needsReviewing = category;
                    maxCount_1 = orangeCategoryCounts_1[category];
                }
            });
            Object.keys(orangeSubcategoryCounts_1).forEach(function (category) {
                if (orangeSubcategoryCounts_1[category] > maxCount_1) {
                    needsReviewing = category;
                    maxCount_1 = orangeSubcategoryCounts_1[category];
                    needsReviewingType = 'subcategory';
                }
            });
        }
    }
    if (!user.hasSeenMessage('analytics') &&
        dayjs_1.default(user.createdAt).isBefore(dayjs_1.default().subtract(4, 'day'))) {
        hasSeenAnalytics = false;
    }
    return (react_1.default.createElement("div", __assign({ style: { marginBottom: 16 } }, other),
        insuficientCategories && (react_1.default.createElement(lab_1.Alert, { style: { marginTop: 8, minHeight: 48 }, severity: "warning" },
            react_1.default.createElement(lab_1.AlertTitle, null, "Try adding categories!"),
            "It will make your card reviews and analytics much more meaningful.")),
        !hasReviewedOldCardsRecently && showStudentMessages && (react_1.default.createElement(lab_1.Alert, { style: { marginTop: 8, minHeight: 48 }, severity: "warning" },
            react_1.default.createElement(lab_1.AlertTitle, null, "Review your old cards!"),
            "Human beings forget roughly 50% of the information that they\u2019ve only learned once after one week.")),
        shortPreviousSession && showStudentMessages && (react_1.default.createElement(lab_1.Alert, { style: { marginTop: 8, minHeight: 48 }, severity: "success" },
            "Let\u2019s try to beat your previous study session time! You\u2019ll need to study for ",
            previousSessionLength + 1,
            " minutes to beat it!")),
        longPreviousSession && showStudentMessages && (react_1.default.createElement(lab_1.Alert, { style: { marginTop: 8, minHeight: 48 }, severity: "success" },
            "Nice work! You studied ",
            previousSessionLength,
            " minutes last time!"))));
};
exports.default = DeckMessages;
//# sourceMappingURL=DeckMessages.js.map